import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useDashboardsQueries } from 'hooks-queries/dashboards'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import { LOAD_DASHBOARD_FOLDER_HEADER_LOG } from './dashboard-folder-header.consts'
import type { IDashboardFolderHeader } from './dashboard-folder-header.types'

export const useDashboardFolderHeaderModel = (): IDashboardFolderHeader => {
  const { folderId } = useParams<{ folderId?: string }>()
  const t = useTranslate()

  const { data, loading } = useDashboardsQueries({
    errorLog: LOAD_DASHBOARD_FOLDER_HEADER_LOG,
    queryName: 'getJobExternalFolder',
    queryVariables: {
      folderId,
    },
  })

  const breadCrumbs = useMemo(() => {
    return [
      {
        title: t(TOLGEE_GLOBALS.dashboards),
        link: getRoute(PATHNAMES.DASHBOARDS),
      },
      {
        title: data?.getWorkspaceJobExternalFolder?.name || '...',
        link: '#',
        isClickBlocked: true,
      },
    ]
  }, [data?.getWorkspaceJobExternalFolder?.name, t])

  return { breadCrumbs, loading }
}
